import baseService from '../shared/baseService';

const clientIdmConversionRateService = (clientId: number) =>
    baseService(`clients/${clientId}/idm-conversion-rates`);

export default { 
    clientIdmConversionRateService
};

